import React from "react";
import { isMobileOrTablet } from "./Views/MobileClassRenderer";

export default function GenericHTMLPageComponent({
  backgroundImage = null,
  content = "",
}) {
  const renderMobileView = () => {
    return (
      <div
        className="view-image-custom d-flex align-items-center justify-content-center"
        style={{
          backgroundImage:
            backgroundImage && `url(${backgroundImage ? backgroundImage : ""})`,
        }}
        data-bg={backgroundImage ? backgroundImage : ""}
      >
        <div className="logout-wrapper has-no-logo">
          <p
            className="logout-wrapper__logout-text"
            dangerouslySetInnerHTML={{ __html: content }}
          ></p>
        </div>
      </div>
    );
  };

  return (
    <>
      {isMobileOrTablet() ? (
        <>{renderMobileView()}</>
      ) : (
        <div
          className="view-image-custom d-flex align-items-center justify-content-center"
          style={{
            backgroundImage:
              backgroundImage &&
              `url(${backgroundImage ? backgroundImage : ""})`,
          }}
          data-bg={backgroundImage ? backgroundImage : ""}
        >
          <div className="logout-wrapper has-no-logo">
            <p
              className="logout-wrapper__logout-text"
              dangerouslySetInnerHTML={{ __html: content }}
            ></p>
          </div>
        </div>
      )}
    </>
  );
}
